const navigation = {
  sections: {
    contentOperations: "مدیریت محتوا",
    personalSetup: "تنظیمات شخصی",
    systemAdministration: "مدیریت سیستم",
  },
  items: {
    dashboard: "داشبورد",
    contentInbox: "صندوق محتوای من",
    promotions: "کمپین‌ها",
    publishingHistory: "تاریخچه انتشار",
    sources: "منابع من",
    filters: "فیلترهای من",
    destinations: "مقصدهای من",
    aiConfiguration: "تنظیمات هوش مصنوعی من",
    teamAccess: "تیم و دسترسی",
    systemSettings: "تنظیمات سیستم",
  },
  titles: {
    dashboard: "داشبورد",
    feed: "صندوق محتوای من",
    history: "تاریخچه انتشار",
    promotion: "کمپین‌ها",
    channels: "کانال‌های منبع",
    filters: "فیلترهای محتوا",
    destination: "مقصدهای من",
    ai: "تنظیمات هوش مصنوعی",
    team: "تیم و دسترسی",
    database: "تنظیمات سیستم",
  },
  mobile: {
    home: "خانه",
    inbox: "محتوا",
    promotions: "کمپین‌ها",
    more: "بیشتر",
    moreDescription: "تاریخچه و تنظیمات فضای کاری",
  },
  account: {
    administrator: "مدیر",
    systemOwner: "مالک سیستم",
    personalWorkspace: "فضای کاری شخصی",
    contentAdmin: "مدیر محتوا",
    owner: "مالک",
    admin: "مدیر",
  },
  status: {
    workspace: "مدیریت محتوای تلگرام با هوش مصنوعی",
    publishingSetupRequired: "تنظیمات انتشار لازم است",
    publishingTargetsReady_one: "{{count}} مقصد انتشار آماده است",
    publishingTargetsReady_other: "{{count}} مقصد انتشار آماده است",
    secureWorkspace: "فضای کاری امن",
    targetsReady_one: "{{count}} مقصد آماده است",
    targetsReady_other: "{{count}} مقصد آماده است",
  },
  accessibility: {
    openDashboard: "باز کردن داشبورد TGReposter",
    closeSidebar: "بستن نوار کناری",
    openSidebar: "باز کردن نوار کناری",
    primaryNavigation: "ناوبری اصلی",
    signOut: "خروج",
    closeMoreNavigation: "بستن منوی بیشتر",
    mobileNavigation: "ناوبری موبایل",
    openPromotionCenter: "باز کردن مرکز کمپین‌ها",
  },
} as const;

export default navigation;
